import { useContext, useEffect, useState } from "react";
import { StyleContext } from "../../providers/StyleContextProvider";
import { ReactComponent as ExternalLink } from '../../assets/svg/external-link.svg';
import { Button } from "../Shared/Buttons/Button";
import { DocumentViewer } from "../Shared/DocumentViewer";
import { getCandidateCVUrlByRecruiter } from "../../helpers/Common";
import { downloadCandidateResume } from "../../services/CandidateService";
import { getCandidateCvDetails } from "../../services/RecruiterService";
import useErrorPage from "../../hooks/useErrorPage";

interface Props {
    recruiterId: number;
    candidateId: number;
    token: string;
}

export const CVTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("applicationStatusTabs");
    const styles = tabStyles.cvTab;
    const [cvTranslationText, setCvTranslationText] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    const [toErrorPage] = useErrorPage();

    useEffect(() => {
        getCandidateCvDetails(props.recruiterId, props.candidateId, props.token)
        .then((response: any) => {
            setCvTranslationText(response.cvTranslationText);
            setFileName(response.cvFileName);
        })
        .catch((error) => {
            toErrorPage(error);
        });
    }, [props.candidateId]);

    const handleDownloadClick = () => {
        downloadApplicantCV();
    }

    const handleViewFullScreenCV = () => {
        const openInBrowser = true;
        const url = getCandidateCVUrlByRecruiter(props.recruiterId, cvTranslationText, props.token, openInBrowser);
        window.open(url, 'CV', '_blank');
    }

    async function downloadApplicantCV() {
        await downloadCandidateResume(cvTranslationText, fileName)
        .then((response: any) => {

        })
        .catch((error) => {
            toErrorPage(error);
        });
    }

    return (
        <>
            <div>
                <div style={styles.rowWrapper}>
                    <div style={styles.text}>CV</div>
                    <div style={styles.link} onClick={handleViewFullScreenCV}>
                        View Full Screen <ExternalLink style={styles.icon} />
                    </div>
                    <Button style={styles.button} onClick={handleDownloadClick}>{"Download"}</Button>
                </div>
                <div style={styles.holder} onClick={handleViewFullScreenCV}>
                    <div style={styles.layer}></div>
                    <p style={styles.name}>{fileName}</p>
                    {cvTranslationText && <DocumentViewer document={getCandidateCVUrlByRecruiter(props.recruiterId, cvTranslationText, props.token)} styles={styles.documentViewer}/>}
                </div>
            </div>
        </>
    );
}
